export default __webpack_public_path__ + "static/media/logo_tn.a1c87697.svg";